import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { Element } from '../common/html/element'

import { COMPONENTS } from '../routers/constants'
import Cart from './cart'
import { STEP } from './constant'
import './lang/i18n'
import OrderConfirmation from './orderConfirmation'
import OrderInformation from './orderInformation'
import { resetStore } from './store/slice'

const CartAndOrders = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const [search] = useSearchParams()
  const isScreening = search.get('screening')

  const step = search.get('step')

  const setStep = (val) => {
    navigate(`${COMPONENTS.cartAndOrders.route}?step=${val}`)
  }

  useEffect(() => {
    return () => {
      dispatch(resetStore())
    }
  }, [])

  return (
    <Element
      className="dFlex justifyContentCenter positionRelative wh100"
      style={{
        backgroundColor: '#F3F3F3',
        minHeight: '100%',
        zIndex: 9,
      }}
    >
      {Number(step) === STEP.SHOPPING_CART || (!step && !isScreening) ? (
        <Cart setStep={setStep} />
      ) : Number(step) === STEP.ORDER_INFORMATION || isScreening ? (
        <OrderInformation setStep={setStep} isScreening={!!isScreening} />
      ) : (
        <OrderConfirmation />
      )}
    </Element>
  )
}

export default CartAndOrders
